import jwtDecode from 'jwt-decode';

export const chPerm = (profile, strict = false) => {
  try {
    const userToken = localStorage.getItem('userToken');
    let currentUser = {};
    currentUser = jwtDecode(userToken);
    if (currentUser && currentUser.status) {
      return (
        currentUser.status.find((perm) => profile.includes(perm)) ||
        (currentUser.status.includes('totalAccess') && !strict)
      );
    }
  } catch {}
  return false;
};
